import { APP_BASENAME } from '@constants/routes';
import type { QaConfig } from './controller';

export const createQaConfig = (origin: string): QaConfig => {
  const apiBase = (process.env.REACT_APP_ESMART_API_BASE_URL || '').trim().replace(/\/+$/, '');
  const configuredPath = (process.env.REACT_APP_AUTH_API_PATH || '').trim() || '/api/auth';
  const authPath = configuredPath.startsWith('/') ? configuredPath : `/${configuredPath}`;
  const loginUrl = new URL(`${apiBase}${authPath.replace(/\/+$/, '')}/token`, origin).href;
  const appPath = `${APP_BASENAME.replace(/\/+$/, '')}/`;
  const timeout = Number(process.env.REACT_APP_API_TIMEOUT_MS);
  return {
    parentOrigins: [origin],
    loginTimeoutMs: Number.isFinite(timeout) && timeout > 0 ? timeout : 15000,
    connectionTimeoutMs: 30000,
    profiles: [{
      id: 'current', label: 'This application', widgetBase: new URL(appPath, origin).href,
      loginUrl, localOnly: false,
    }],
  };
};
